import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { IoDrugGroup, IoDiagnosis, IoDrug } from '../../types';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import * as _ from 'lodash';
import { DrugDetailPage } from '../drug-detail/drug-detail';
import * as JsSearch from 'js-search';
import { DataProvider, sort } from '../../providers/data/data';
import { DrugFilterSettings, FilterSettingsComponent } from '../../components/filter-settings/filter-settings';
import { SettingsProvider } from '../../providers/settings/settings';
import { DrugDataStore } from '../../providers/data/drug-data-store';

/**
 * Generated class for the DrugCategoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-drug-category',
  templateUrl: 'drug-category.html',
})
export class DrugCategoryPage {

  prefilter: 'relatedToDiagnosis' | 'unrelated' = 'relatedToDiagnosis';
  selectedGroup: IoDrugGroup;
  selectedDiagnosis: IoDiagnosis;
  filteredDrugs: Array<IoDrug> = [];
  allDrugs: Array<IoDrug>;
  drugsIndex: JsSearch.Search;
  searchText: string;
  filterSettings: DrugFilterSettings = { showTrademarks: true };

  constructor(public navCtrl: NavController, public navParams: NavParams, private analytics: AnalyticsProvider,
    private data: DrugDataStore,
    settingsProvider: SettingsProvider) {
    [this.selectedGroup, this.selectedDiagnosis] = navParams.data;
    if (!this.selectedDiagnosis) {
      this.prefilter = 'unrelated';
    }

    const showTrademarksRemembered = settingsProvider.getLocalBool(FilterSettingsComponent.showTrademarksSettingsKey);
    if (showTrademarksRemembered !== null) {
      this.filterSettings.showTrademarks = showTrademarksRemembered;
    }
  }

  drugClicked(drug: IoDrug) {
    this.analytics.emitEvent('drugCategory', 'drugSelected');
    this.navCtrl.push(DrugDetailPage, [drug, this.selectedDiagnosis]);
  }

  belongsToPrefilter(drug: IoDrug) {
    const hasEffect = _.some(this.data.getEffectsOfDrug(drug), effect => this.data.getDiagnosisOfEffect(effect) === this.selectedDiagnosis);
    if (this.prefilter === 'relatedToDiagnosis') {
      return hasEffect;
    } else {
      return !hasEffect;
    }
  }

  getProbability(drug: IoDrug) {
    const effect = _.find(this.data.getEffectsOfDrug(drug), effect => this.data.getDiagnosisOfEffect(effect) === this.selectedDiagnosis);
    return effect
      ? effect.probability
      : -1;
  }

  ionViewDidLoad() {
    this.drugsIndex = DataProvider.createIndex('id', 'name');
    this.drugsIndex.addIndex('registrationInfo');
    this.allDrugs = this.data.getDrugsOfGroup(this.selectedGroup);

    sort(this.allDrugs);

    this.drugsIndex.addDocuments(this.allDrugs);
    this.filterItems();
  }

  filterItems() {
    let val = this.searchText;
    val = (val || '').trim();

    let matches: Array<IoDrug>;
    if (val) {
      this.analytics.emitEvent('drugCategory', 'searchInputLength', val.length + '');
      matches = this.drugsIndex.search(val) as Array<IoDrug>;
    } else {
      this.analytics.emitEvent('drugCategory', 'searchReset');
      matches = this.allDrugs;
    }

    this.filteredDrugs = matches.filter(d => this.belongsToPrefilter(d));

    if (!this.filterSettings.showTrademarks) {
      this.filteredDrugs = this.filteredDrugs.filter(d => !d.isTrademark);
    }

    sort(this.filteredDrugs);

    this.data.calculateEffectStatsWhereMissing(this.filteredDrugs);
  }

  onPrefilterChange(value: string) {
    this.analytics.emitEvent('drug-group', 'prefilter', value);
    this.filterItems();
  }

  handleSettingsChanged(settings: DrugFilterSettings) {
    this.filterSettings = settings;
    this.filterItems();
  }

}



// WEBPACK FOOTER //
// ./src/pages/drug-category/drug-category.ts